import styled from 'styled-components';
import { Base, Theme } from 'styled';

type ContainerProps = {
  popUpIsActive: boolean;
  removeWithAnimation: boolean;
  hidePopUp: boolean;
};

type PopUpProps = {
  isShowingVideoPane: boolean;
};

type VideoPaneProps = {
  isShowingVideoPane: boolean;
  showOrHideWithAnimation: boolean;
};

type FormPaneProps = {
  isShowingVideoPane: boolean;
};

export const Container = styled(Base)<ContainerProps>`
  ${({ theme }) => theme.zIndex('pop-up')};
  ${({ popUpIsActive, theme }) => popUpIsActive && theme.animations.fadeIn};
  ${({ removeWithAnimation, popUpIsActive, theme }) =>
    removeWithAnimation && !popUpIsActive && theme.animations.fadeOut};
  pointer-events: ${({ popUpIsActive }) => (popUpIsActive ? 'auto' : 'none')};
  opacity: ${({ removeWithAnimation, popUpIsActive }) =>
    !removeWithAnimation && !popUpIsActive ? 0 : 1};
  display: ${({ hidePopUp }) => (hidePopUp ? 'none' : 'flex')};
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${({ theme }) => theme.sizes.topBarHeightMobile};
  height: ${({ theme }) => `calc(100vh - ${theme.sizes.topBarHeightMobile})`};

  ${Theme.mediaQueries.sm} {
    margin-top: ${({ theme }) => theme.sizes.topBarHeightTablet};
    height: ${({ theme }) => `calc(100vh - ${theme.sizes.topBarHeightTablet})`};
    padding: 1.5rem 1.8125rem;
  }

  ${Theme.mediaQueries.md} {
    margin-left: ${({ theme }) => theme.sizes.sideNavWidthDesktop};
    margin-top: 0;
    width: ${({ theme }) => `calc(100vw - ${theme.sizes.sideNavWidthDesktop})`};
    height: 100vh;
  }
`;

export const Background = styled(Base)`
  background-color: ${({ theme }) => theme.colors['blue-darker']};
  ${({ theme }) => theme.transitions['transition-short']};
`;

export const PopUp = styled(Base)<PopUpProps>`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.zIndex('1')};
  max-width: 46.375rem;
  height: 100%;

  ${Theme.mediaQueries.sm} {
    height: ${({ isShowingVideoPane }) =>
      isShowingVideoPane ? 'auto' : '100%'};
  }
`;

export const VideoPane = styled(Base)<VideoPaneProps>`
  ${({ theme }) => theme.transitions.transition};
  ${({ showOrHideWithAnimation, isShowingVideoPane, theme }) => {
    if (showOrHideWithAnimation) {
      return isShowingVideoPane
        ? theme.animations.fadeIn
        : theme.animations.fadeOut;
    }
  }};
  pointer-events: ${({ isShowingVideoPane }) =>
    isShowingVideoPane ? 'auto' : 'none'};
  opacity: ${({ showOrHideWithAnimation, isShowingVideoPane }) =>
    !showOrHideWithAnimation && !isShowingVideoPane ? 0 : 1};
  display: ${({ isShowingVideoPane, showOrHideWithAnimation }) =>
    !isShowingVideoPane && !showOrHideWithAnimation ? 'hidden' : 'flex'};
  flex-direction: column;
`;

export const CloseButtonContainer = styled(Base)``;

export const VideoPaneTitleContainer = styled(Base)`
  ${({ theme }) => theme.typography.variants.primary.lg};

  span {
    display: block;
  }
`;

export const VideoContainer = styled(Base)``;

export const FormPane = styled(Base)<FormPaneProps>`
  width: 100%;
  height: 100%;
  ${({ theme }) => theme.transitions.transition};
  ${({ isShowingVideoPane, theme }) => {
    if (isShowingVideoPane) return theme.animations.fadeOut;
  }};

  max-height: ${({ isShowingVideoPane }) => (isShowingVideoPane ? 0 : 'unset')};
`;

export const FormTitleContainer = styled(Base)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled(Base)`
  ${({ theme }) => theme.typography.variants.primary.md};
  max-width: 9.5625rem;

  ${Theme.mediaQueries.md} {
    ${({ theme }) => theme.typography.variants.primary.lg};
    max-width: 14.3125rem;
  }
`;

export const FormDescription = styled(Base)`
  ${({ theme }) => theme.typography.variants.secondary.sm};

  ${Theme.mediaQueries.md} {
    max-width: 13.375rem;
    margin-right: 3rem;
  }
`;

export const FormContainer = styled(Base).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['display'].includes(prop) && defaultValidatorFn(prop),
})``;

export const Form = styled(Base)`
  ${Theme.mediaQueries.md} {
    margin-top: -2.5rem;
  }
`;
